const IPV4_REGEX = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
export function isValidIpv4(value) {
    const match = IPV4_REGEX.exec(value.trim());
    if (!match)
        return false;
    return match.slice(1).every((segment) => Number(segment) <= 255);
}
// Comparing dotted IPv4 strings lexicographically (even with dots stripped) sorts wrong, e.g. "9.0.0.1"
// would be treated as greater than "10.0.0.1". Returns undefined for anything that isn't a valid IPv4
// address instead of silently computing a meaningless number.
export function parseIpv4(value) {
    if (!isValidIpv4(value)) {
        return undefined;
    }
    return value
        .trim()
        .split(".")
        .reduce((total, octet) => total * 256 + Number(octet), 0);
}
//# sourceMappingURL=ip-address.js.map